import { NavigationType } from "../types";

type BuildNavigationType = () => NavigationType;

const buildNavigationType: BuildNavigationType = () => {
  const navigationEntries = performance.getEntriesByType(
    "navigation"
  ) as PerformanceNavigationTiming[];

  if (!navigationEntries || navigationEntries.length === 0) {
    return NavigationType.Unknown;
  }

  const [navigationEntry] = navigationEntries;

  switch (navigationEntry.type) {
    case "navigate":
      return NavigationType.Navigate;
    case "reload":
      return NavigationType.Reload;
    case "back_forward":
      return NavigationType.BackForward;
    default:
      return NavigationType.Unknown;
  }
};

export { buildNavigationType };
